import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import styles from './ToolCard.module.scss';

function ToolCard({ title, icon, to, className }: IToolCard) {
  return (
    <NavLink
      to={to}
      className={classNames(styles.root, className)}
    >
      <img
        src={icon}
        alt="icon"
        className="m-r-xs"
      />
      <div className="h3">{title}</div>
    </NavLink>
  );
}

export default ToolCard;
